<template>
<v-combobox
  dense
  outlined
  class="ec-font-size16"
  :value="value"
  :items="items"
  :item-text="itemText"
  :item-value="itemValue"
  :loading="loading"
  :hide-details="!error"
  :rules="validate"
  :error-messages="errors"
  :placeholder="placeholder"
  background-color="rgba(var(--b3f,250,250,250),1)"
  @input="updateValue"
></v-combobox>
</template>
<script>
import ValidationLib from '@/libs/ValidationLib'

export default {
  name: 'ComponentsItemsComboBox',

  data () {
    return {
      validate: [],
      placeholder: '',
      error: false,
      errors: ''
    }
  },

  created: function () {
    this.validate = ValidationLib.rules(this.name)
    this.placeholder = ValidationLib.placeholder(this.name)
  },

  methods: {
    updateValue: function (e) {
      this.$emit('update:value', e)
    },

    isError: function () {
      return (this.errors !== '')
    },

    confirm: function () {
      return new Promise((resolve, reject) => {
        try {
          this.errors = ''
          for (var y = 0; y < this.validate.length; y++) {
            const err = this.validate[y](this.value)
            if (err !== true) {
              this.errors = err
              break
            }
          }
          if (this.isError()) {
            this.error = true
            return resolve(false)
          }
          this.error = false
          return resolve(true)
        } catch (e) {
          return reject(e)
        }
      })
    }
  },

  props: {
    name: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      required: true,
      default: () => []
    },
    itemText: {
      type: String,
      required: false,
      default: () => 'code'
    },
    itemValue: {
      type: String,
      required: false,
      default: () => 'name'
    },
    value: {
      type: [String, Array],
      required: true,
      default: () => ''
    },
    loading: {
      type: [String, Boolean],
      required: false,
      default: () => false
    }
  }
}
</script>
